<template>
    <div>
        
        <h4 class="clear">
            <div class="pull-left">
                #{{ data.id }} - {{ types[data.type] }} <span v-if="data.description"> - {{ data.description }}</span>
            </div>
        </h4>
        
        <br />
                
        <div class="product-info" v-if="data.product_id">
            <product :id="data.product_id"></product>
        </div>
        
        <div class="text-right">
            <small>{{ data.created_at }}</small>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Product from './Product.vue'
    
    export default {
        name: 'Notification',
        props: ["data", "types"],
        data() {
            return {    
            }
        },
        components: {
            Product
        },
        methods: {
            update() {
            }
        },
        watch: {
            data: {
                handler: function (newData, oldData) {
                    this.data = newData;
                },
            },
            types: {
                handler: function (newData, oldData) {
                    this.types = newData;
                },
            }
        },
    }
</script>

<style>
    .product-info {
        margin-top:15px;
    }
</style>


// WEBPACK FOOTER //
// Notification.vue?7ad902fe